import React, { useEffect, useState } from "react";
import TeamDB from "./TeamDB";
import {
  parseTerms,
  parseTermSearchQuery,
  useQuery,
} from "../../utils/GeneralUtils";
import { useMetaData } from "../../utils/useMetaData";
import { useGetTeams } from "../../utils/useTeam";
import { useLocation, useNavigate } from "react-router-dom";
import { TermType, useGetTerm } from "../../utils/useTerm";
import {
  checkParamExist,
  getCurrentPage,
  getCurrentPerView,
  getParam,
  getParamAll,
  handlePerView,
  searchClearHandler,
  searchHandler,
  SearchParam,
} from "../../common/archive/ListSearchFunc";

const TeamDBContainer: React.FC = () => {
  const query = useQuery();
  const location = useLocation();
  const navigate = useNavigate();

  const {
    termData: { entries: games },
    getTermLoading: isGameLoading,
  } = useGetTerm(TermType.Games, undefined, -1);

  // ターム関連のパラメーターが存在する場合、コンテンツの取得を一時停止します
  const [enabled, setEnabled] = useState<boolean>(
    !checkParamExist(query, [TermType.Games])
  );

  useEffect(() => {
    if (enabled === true) return;

    if (!isGameLoading) {
      setEnabled(true);
    }
  }, [isGameLoading]);

  let selectedGames: { ids: Array<string>; names: Array<string> } = {
    ids: [],
    names: [],
  };
  if (!isGameLoading) {
    const gameParams = getParamAll(query, TermType.Games);
    selectedGames = {
      ids: parseTermSearchQuery(gameParams, games, "id"),
      names: gameParams,
    };
  }

  const searchArgs = {
    search: getParam(query, "s"),
    page: getCurrentPage(query),
    per: getCurrentPerView(query),
    desc: true,
    games: selectedGames.ids.length > 0 ? selectedGames.ids : [],
  };

  const {
    items: { teams, total_entries: entries, total_pages: totalPage },
    isLoading,
  } = useGetTeams(searchArgs, enabled);

  useMetaData({
    title: "eスポーツチーム一覧",
    description:
      "eスポーツを使ったPRやイベントキャスティングサービス「SELeCT」のeスポーツやゲームのプロチーム、企業チーム、アマチュアチームの一覧ページです。チームメンバーやSNSの閲覧ができます。キーワード・カテゴリでの検索をご利用いただけます。",
    imgUrl: "",
  });

  return (
    <TeamDB
      keywordParam={searchArgs.search ?? ""}
      teams={teams}
      isLoading={isLoading}
      perView={searchArgs.per}
      totalPage={totalPage}
      currentPage={searchArgs.page}
      totalEntries={entries}
      handlePerView={(value: number) =>
        handlePerView(query, location, navigate, value)
      }
      searchHandler={(params: Array<SearchParam>) => {
        searchHandler(query, params, navigate);
      }}
      clearSearch={() => searchClearHandler(navigate)}
      gameParams={selectedGames.names}
      gameOptions={games ? parseTerms(games, "name") : []}
    />
  );
};

export default TeamDBContainer;
